import { FieldValues, FormState, Path, UseFormRegister } from "react-hook-form";

import { Input, InputProps } from "@fronterahealth/frontera-ui-components/Input/Input";

import { LanguageMappingInterface } from "@components/forms/interfaces";
import { getErrorFromFormKey, getLabelFromFormKey } from "@components/forms/utils";

interface Props<T extends FieldValues> extends Omit<InputProps, "name" | "pattern" | "ref"> {
  register: UseFormRegister<T>;
  formState: FormState<T>;
  formKey: Path<T>;
  mapping?: LanguageMappingInterface<T>;
  pattern?: RegExp;
  required?: boolean;
  customErrorMessage?: string;
}

export const FormInput = <T extends FieldValues>({
  formState,
  formKey,
  register,
  pattern,
  mapping,
  label,
  required = true,
  ...props
}: Props<T>) => {
  const inputLabel = mapping ? getLabelFromFormKey(formKey, mapping, "en") : label;
  const errorMessage = getErrorFromFormKey(formKey, formState.errors, props.customErrorMessage);
  return (
    <Input
      label={inputLabel}
      hintText={required ? undefined : "Optional"}
      inputSize="full"
      {...register(formKey, {
        required: {
          value: required,
          message: `${label} is required`,
        },

        pattern: pattern
          ? {
              value: pattern,
              message: `${label} must match pattern above`,
            }
          : undefined,
      })}
      errorMessage={errorMessage}
      {...props}
    />
  );
};
